import { BrowserRouter } from 'react-router-dom';

import { SnackbarContextProvider } from '~/components/organisms/SnackbarContext';

import PreviousLocationTracker from '~/redux/slices/location/PreviousLocationTracker';
import HistoryCounter from '~/routes/HistoryCounter';
import { MenuRouter } from '~/routes/MenuRouter';
import PopupRouter from '~/routes/PopupRouter';
import WelcomeScreen from '~/routes/WelcomeScreen';

import RootNavigator from './RootNavigator';

const Router = () => (
  <BrowserRouter>
    <PreviousLocationTracker />
    <HistoryCounter>
      <SnackbarContextProvider>
        <RootNavigator />
        <PopupRouter />
        <MenuRouter />
      </SnackbarContextProvider>
    </HistoryCounter>
    <WelcomeScreen />
  </BrowserRouter>
);

export default Router;
